import {Component, OnInit, Input, AfterViewInit, ViewChild} from '@angular/core';
import {MatTab, MatTabGroup} from '@angular/material';

import {Airport} from '../models/airport.model';


@Component({
  selector: 'app-local-panel',
  templateUrl: './local-panel.component.html',
  styleUrls: ['./local-panel.component.scss']
})
export class LocalPanelComponent implements OnInit, AfterViewInit {
  @Input() airport: Airport;
  @Input() isIslandSource: boolean;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedTab: MatTab;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    // Workaround to correctly set the initially selected tab. Wrapped in setTimeout to avoid triggering
    // change detection error ("Expression has changed after it was checked").
    setTimeout(() => {
      this.selectedTab = this._getSelectedTab();
    }, 0);
  }

  onSelectTab(event) {
    this.selectedTab = event.tab;
  }

  private _getSelectedTab(): MatTab {
    if (!this.tabGroup._tabs) {
      return null;
    }
    return this.tabGroup._tabs
      .toArray()
      .find((tab: MatTab, i: number) => i === this.tabGroup.selectedIndex);
  }
}
